<template>
    <form @submit.prevent="onSubmit" v-if="form_data">
        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="ex_rate_offset">Exchange Rate Offset</label>
                <small>Used in the calculation of landed cost. Actual landed may be different.</small>
                <input type="text" name="ex_rate_offset" id="ex_rate_offset" class="form-control"
                       placeholder="" v-model.number="form_data.exchange_rate_offset">
                <div>
                    <i>Current exchange rate: <strong>{{exRate}}</strong>. Rate with offset: <strong>{{effectiveExRate}}</strong></i>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-default">Save</button>
    </form>
</template>
<script>
    import {mapState} from 'vuex'
    import {handleHttpError} from '../../util/common'
    import api from '../../api/api_resource';

    export default {
        created() {
            this.getData()
        },
        data() {
            return {
                form_data: {
                    exchange_rate_offset: 0
                }
            }
        },
        computed: {
            exRate(){
                return window.currencyRate.nzd.toFixed(2);
            },
            effectiveExRate(){
                let offset = 0;
                if (this.form_data.exchange_rate_offset) {
                    offset = this.form_data.exchange_rate_offset;
                }
                return (window.currencyRate.nzd + offset).toFixed(2);
            }
        },
        methods: {
            onSubmit: function () {
                return new Promise((success, reject) => {
                    api.store('settings', this.form_data).then(result => {
                        this.form_data = result.setting;
                        this.$message.success(result.message);
                    }).catch(error => {
                        this.$message.error(error.message);
                    });
                });
            },
            async getData(){
                try {
                    let res = await this.axios.get(this.$laravelRoute('settings.index'))
                    if (res.data && res.data.settings) {
                        this.form_data = res.data.settings
                    }
                } catch (e) {
                    console.warn('error getting settings', e)
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Forms/Settings.vue